import PropTypes from "prop-types";
import * as React from "react";
import { addonPropType } from "../../domain";
import SexyButton from "../../theme/SexyButton";
import OrderAddonBadge, { withCancelled } from "../Addons/AddonBadge";
import PurchaseModal, { PURCHASE_TYPES } from "../PurchaseModal";

export default function VideoRecordingAddon({
  autographPurchaseId,
  isCancelled,
  addon,
  has,
  onPurchase,
  canPurchase,
}) {
  const purchaseProps = React.useMemo(
    () => ({
      type: PURCHASE_TYPES.ADDON_PURCHASE,
      name: addon.name,
      title: addon.title,
      description: addon.description,
      amount: addon.price.value * 100,
      autographPurchaseId,
    }),
    [addon, autographPurchaseId],
  );

  const action = React.useMemo(() => {
    return withCancelled(isCancelled, () =>
      has ? (
        <SexyButton className="green" disabled>
          Purchased
        </SexyButton>
      ) : (
        <PurchaseModal onPurchase={onPurchase} purchase={purchaseProps} />
      ),
    );
  }, [onPurchase, purchaseProps, isCancelled, has]);

  return (
    <OrderAddonBadge
      title={addon.title}
      description={addon.description}
      icon={addon.icon}
      action={has || canPurchase ? action : null}
    />
  );
}

VideoRecordingAddon.propTypes = {
  addon: addonPropType.isRequired,
  autographPurchaseId: PropTypes.number.isRequired,
  isCancelled: PropTypes.bool,
  has: PropTypes.bool,
  onPurchase: PropTypes.func,
  canPurchase: PropTypes.bool,
};
